import type { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import { formFields, SchemaForm, YStack } from "@medbillai/ui";
export const SignInSchema = z.object({
  email: formFields.text.email().min(1, "Email is required").describe("Email")
});
export const SignInForm = ({
  form,
  onSubmit,
  placeholder = "example@email.com"
}: {
  form: UseFormReturn<{
    email: string;
  }>;
  onSubmit: (data: z.infer<typeof SignInSchema>) => void;
  placeholder?: string;
}) => {
  return <SchemaForm form={form} schema={SignInSchema} onSubmit={onSubmit} defaultValues={{
    email: ""
  }} formProps={{
    flex: 0
  }} props={{
    email: {
      placeholder,
      autoCorrect: false,
      spellCheck: false
    }
  }} data-sentry-element="SchemaForm" data-sentry-component="SignInForm" data-sentry-source-file="SignInForm.tsx">
      {fields => <YStack gap="$3">{Object.values(fields)}</YStack>}
    </SchemaForm>;
};